module.exports = __webpack_public_path__ + "img/icon-zoom-out.e6ef4b40.svg";